class FAQ_Collapsible extends HTMLElement {
  constructor() {
    super();
    this.collapsibleTabs = document.querySelectorAll(".collapsible-tab");
    this.collapsibleElements = document.querySelectorAll(".accordion-tab");
  }

  connectedCallback() {
    this.collapsibleTabs?.forEach((tab) => {
      tab.addEventListener("click", this.changeActiveTab);
    });
  }

  disconnectedCallback() {
    this.collapsibleTabs?.forEach((tab) => {
      tab.removeEventListener("click", this.changeActiveTab);
    });
  }

  changeActiveTab = (event) => {
    const tab = event.currentTarget;
    const activeTab = tab.getAttribute("data-tab");
    this.collapsibleTabs.forEach((tab) => {
      tab.classList.remove("active-collapsible-tab");
    });

    this.collapsibleElements.forEach((element) => {
      const elementTab = element.getAttribute("data-tab");
      if (elementTab === activeTab) {
        element.classList.add("active-accordion-tab");
      } else {
        element.classList.remove("active-accordion-tab");
      }
    });

    tab.classList.add("active-collapsible-tab");
  };
}

if (!window.customElements.get("faq-collapsible")) {
  window.customElements.define("faq-collapsible", FAQ_Collapsible);
}

(function () {
  const initCollapsibleContent = (container) => {
    $(container)
      .find(".collapsible-content__toggle")
      .unbind("click")
      .on("click", function () {
        const parent = $(this).parent();
        const collapsibleContainer = $(this).closest(".accordion-tab");

        if (!parent.hasClass("active")) {
          collapsibleContainer
            .find(".collapsible-content__item.active")
            .removeClass("active");
          collapsibleContainer
            .find(".collapsible-content__answer")
            .stop()
            .slideUp(300);

          parent.addClass("active");
          $(this).next().stop().slideDown(300);
        } else {
          parent.removeClass("active");
          $(this).next().stop().slideUp(300);
        }
      });
  };

  const initSlider = () => {
    const slider = document.querySelector(".collapsible-content__content");

    if (slider) {
      let swiperParams = {
        slidesPerView: "auto",
        spaceBetween: 28,
        breakpoints: {
          576: {
            slidesPerView: 2,
            spaceBetween: 32
          },
          750: {
            slidesPerView: 2,
            spaceBetween: 64
          },
          990: {
            slidesPerView: "auto",
            spaceBetween: 0,
          }
        }
      };

      let swiper;

      if (window.innerWidth < 749) {

        swiper = new Swiper(slider, swiperParams);
      } else {
        if (swiper) {
          swiper.destroy(true, true);
          swiper = undefined;
        }
      }
    }
  };

  document.addEventListener("shopify:section:load", function (event) {
    const container = event.target;
    initCollapsibleContent(container);
  });
  initSlider();
  window.addEventListener("resize", initSlider);

  $(".accordion-tab").each(function () {
    initCollapsibleContent(this);
  });
})();
